<template>
  <div class="website">
    <v-select v-model="values" :items="filtredItems" item-text="name" item-value="id" :label="label" chips
      :multiple="multiple" :readonly="readonly">
      <template v-slot:prepend-item v-if="sortList === null">
        <v-list-item ripple>
          <v-text-field v-model="search" label="Фильтровать" />
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
  </div>
</template>
<script>
export default {
  name: "website",
  components: {},
  data: () => ({
    search: "",
    active: [],
    items: [],
  }),
  props: {
    value: {},
    label: { type: String, default: "Сайт банка" },
    sortList: null,
    readonly: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true }
  },
  methods: {
    async getAllSites() {
      const { data } = await this.$store.dispatch("getAllWebsite");
      this.items = data.sort((a, b) => a.name < b.name ? -1 : 1);
    },
  },
  computed: {
    values: {
      get() {
        // console.log('this.value',this.value);
        return typeof this.value === 'string'  ? JSON.parse(this.value) : this.value;
      },
      set(val) {
        this.$emit("input", JSON.stringify(val));
      },
    },
    filtredItems() {
      // console.log('filtredItems this.sortList',this.sortList, typeof this.sortList);
      if (this.sortList == null) {
        // console.log('is search',);
        return this.search
          ? this.items.filter((item) =>
            new RegExp(this.search, "gi").test(item.name)
          )
          : this.items;
      } else {
        const list = typeof this.sortList === 'string' ? JSON.parse(this.sortList) : this.sortList
        const result = new Array
        for (let i of list) {
          const row = this.items.filter(item => item.id == i)
          row && result.push(row[0])
        }
        return result
      }
    },
  },
  async mounted() {
    await this.getAllSites();
  },
  watch: {},
};
</script>
<style lang="sass" scoped>
</style>
